/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

'use client';

import { useRouter } from 'next/navigation';
import { type ReactNode, useEffect } from 'react';

/**
 * This component will prevent NextJS from pre-loading other pages that
 * are linked from the page that this component is mounted on. This was
 * built for the vehicle catalog page because in production NextJS was
 * pre-loading each vehicle details page for **each** card displayed which
 * was causing noticable performance issues for slower devices.
 */
export function StopPrefetch(): ReactNode {
  const router = useRouter();

  useEffect(() => {
    const { prefetch } = router;

    // eslint-disable-next-line react-hooks/immutability
    router.prefetch = async () => {};

    return () => {
      router.prefetch = prefetch;
    };
  }, [router]);

  return null;
}
